// Enum para formas de pagamento
export enum FormasPagamentoEnum {
  DINHEIRO = 'DINHEIRO',
  CARTAO_DE_CREDITO = 'CARTAO_DE_CREDITO',
  PIX = 'PIX',
  CARTAO_DE_DEBITO = 'CARTAO_DE_DEBITO',
  DEPOSITO_CONTA = 'DEPOSITO_CONTA',
  CHEQUE = 'CHEQUE',
  BOLETO = 'BOLETO',
  TRANSFERENCIA = 'TRANSFERENCIA',
  NOTA_PROMISSORIA = 'NOTA_PROMISSORIA',
  DEPOSITO_SERVICO_ELETRONICO = 'DEPOSITO_SERVICO_ELETRONICO'
}

// Mapeamento de labels para as formas de pagamento
export const formasPagamentoLabels: Record<string, string> = {
  [FormasPagamentoEnum.DINHEIRO]: 'Dinheiro',
  [FormasPagamentoEnum.CARTAO_DE_CREDITO]: 'Cartão de Crédito',
  [FormasPagamentoEnum.PIX]: 'PIX',
  [FormasPagamentoEnum.CARTAO_DE_DEBITO]: 'Cartão de Débito',
  [FormasPagamentoEnum.DEPOSITO_CONTA]: 'Transf./Depósito',
  [FormasPagamentoEnum.CHEQUE]: 'Cheque',
  [FormasPagamentoEnum.BOLETO]: 'Boleto',
  [FormasPagamentoEnum.TRANSFERENCIA]: 'Transferência Bancária',
  [FormasPagamentoEnum.NOTA_PROMISSORIA]: 'Nota Promissória',
  [FormasPagamentoEnum.DEPOSITO_SERVICO_ELETRONICO]: 'Creditado pela Central de Serv. Eletrônicos',
}

// Array para uso em selects/dropdowns
export const formasPagamentoOptions = Object.values(FormasPagamentoEnum).map(value => ({
  value,
  label: formasPagamentoLabels[value],
}))

// Função utilitária para obter o label de uma forma de pagamento
export function getFormasPagamentoLabel (forma: string): string {
  return formasPagamentoLabels[forma] || forma
}

// Função utilitária para obter ícone do tipo de pagamento
export function getFormasPagamentoIcon (tipo: string): string {
  const icones: Record<string, string> = {
    [FormasPagamentoEnum.DINHEIRO]: 'fas fa-money-bill-wave',
    [FormasPagamentoEnum.PIX]: 'fas fa-qrcode',
    [FormasPagamentoEnum.CARTAO_DE_CREDITO]: 'fas fa-credit-card',
    [FormasPagamentoEnum.CARTAO_DE_DEBITO]: 'fas fa-credit-card',
    [FormasPagamentoEnum.TRANSFERENCIA]: 'fas fa-exchange-alt',
    [FormasPagamentoEnum.DEPOSITO_CONTA]: 'fas fa-exchange-alt',
    [FormasPagamentoEnum.BOLETO]: 'fas fa-barcode',
    [FormasPagamentoEnum.CHEQUE]: 'fas fa-money-check',
    [FormasPagamentoEnum.NOTA_PROMISSORIA]: 'fas fa-file-contract',
    [FormasPagamentoEnum.DEPOSITO_SERVICO_ELETRONICO]: 'fas fa-globe',
  }
  return icones[tipo] || 'fas fa-dollar-sign'
}
